'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';

import { useConsent } from 'utils/consent/ConsentProvider';
import { CURRENT_ENV } from 'utils/constants';

export const DatadogScript = () => {
  const { hasPerformanceConsent, isLoaded } = useConsent();
  const initialized = useRef(false);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    if (!hasPerformanceConsent) {
      return;
    }
    if (initialized.current) {
      return;
    }

    const applicationDDId = process.env.NEXT_PUBLIC_DATADOG_APP_ID;
    const clietTokenDD = process.env.NEXT_PUBLIC_DATADOG_CLIENT_ID;
    const currentEnv = CURRENT_ENV;

    if (!applicationDDId || !clietTokenDD) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log('Datadog consent given, initializing Datadog RUM');

    datadogRum.init({
      applicationId: applicationDDId,
      clientToken: clietTokenDD,
      site: 'us5.datadoghq.com',
      service: 'magmutual-website',
      env: currentEnv,
      version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.startSessionReplayRecording();

    document.addEventListener('securitypolicyviolation', e => {
      datadogRum.addError(new Error('CSP Violation'), {
        blockedURI: e.blockedURI,
        violatedDirective: e.violatedDirective,
        originalPolicy: e.originalPolicy,
        disposition: e.disposition,
        sourceFile: e.sourceFile,
        lineNumber: e.lineNumber,
      });
    });

    initialized.current = true;
  }, [hasPerformanceConsent, isLoaded]);

  return null; // no DOM output
};
